/* tslint:disable */
/* eslint-disable */
/**
 * LendMore API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Car,
    CarFromJSON,
    CarFromJSONTyped,
    CarToJSON,
    Child,
    ChildFromJSON,
    ChildFromJSONTyped,
    ChildToJSON,
    HasOldLoan,
    HasOldLoanFromJSON,
    HasOldLoanFromJSONTyped,
    HasOldLoanToJSON,
    PaymentMethod,
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
    SharedExpenses,
    SharedExpensesFromJSON,
    SharedExpensesFromJSONTyped,
    SharedExpensesToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApplicationRequest
 */
export interface ApplicationRequest {
    /**
     * 
     * @type {number}
     * @memberof ApplicationRequest
     */
    loanAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationRequest
     */
    startAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationRequest
     */
    repaymentPeriod?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    cpr: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    oldLoanAmount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    mobile?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    postalcode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    city?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationRequest
     */
    aseConsent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationRequest
     */
    marketingConsent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationRequest
     */
    almBrandConsent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    coname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    coemail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    cocpr?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    married?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationRequest
     */
    rki?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    dwelling?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    rent?: string | null;
    /**
     * 
     * @type {Array<Child>}
     * @memberof ApplicationRequest
     */
    children?: Array<Child> | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    reasonOfLoan?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    otherReasonOfLoan?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationRequest
     */
    coappliant?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    maritalExpenses?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    regNr?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    accountNr?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationRequest
     */
    termsOfService: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationRequest
     */
    marketing: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationRequest
     */
    creditCheck: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationRequest
     */
    eSkatConsent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationRequest
     */
    insurance: boolean;
    /**
     * 
     * @type {Array<Car>}
     * @memberof ApplicationRequest
     */
    cars?: Array<Car> | null;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof ApplicationRequest
     */
    paymentMethod: PaymentMethod;
    /**
     * 
     * @type {HasOldLoan}
     * @memberof ApplicationRequest
     */
    hasOldLoan: HasOldLoan;
    /**
     * 
     * @type {SharedExpenses}
     * @memberof ApplicationRequest
     */
    sharedExpenses: SharedExpenses;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    step2AltLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRequest
     */
    step2AltText?: string | null;
}

export function ApplicationRequestFromJSON(json: any): ApplicationRequest {
    return ApplicationRequestFromJSONTyped(json, false);
}

export function ApplicationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'loanAmount': !exists(json, 'loanAmount') ? undefined : json['loanAmount'],
        'startAmount': !exists(json, 'startAmount') ? undefined : json['startAmount'],
        'repaymentPeriod': !exists(json, 'repaymentPeriod') ? undefined : json['repaymentPeriod'],
        'cpr': json['cpr'],
        'oldLoanAmount': !exists(json, 'oldLoanAmount') ? undefined : json['oldLoanAmount'],
        'name': json['name'],
        'mobile': !exists(json, 'mobile') ? undefined : json['mobile'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'postalcode': !exists(json, 'postalcode') ? undefined : json['postalcode'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'aseConsent': !exists(json, 'aseConsent') ? undefined : json['aseConsent'],
        'marketingConsent': !exists(json, 'marketingConsent') ? undefined : json['marketingConsent'],
        'almBrandConsent': !exists(json, 'almBrandConsent') ? undefined : json['almBrandConsent'],
        'coname': !exists(json, 'coname') ? undefined : json['coname'],
        'coemail': !exists(json, 'coemail') ? undefined : json['coemail'],
        'cocpr': !exists(json, 'cocpr') ? undefined : json['cocpr'],
        'married': !exists(json, 'married') ? undefined : json['married'],
        'rki': !exists(json, 'rki') ? undefined : json['rki'],
        'dwelling': !exists(json, 'dwelling') ? undefined : json['dwelling'],
        'rent': !exists(json, 'rent') ? undefined : json['rent'],
        'children': !exists(json, 'children') ? undefined : (json['children'] === null ? null : (json['children'] as Array<any>).map(ChildFromJSON)),
        'reasonOfLoan': !exists(json, 'reasonOfLoan') ? undefined : json['reasonOfLoan'],
        'otherReasonOfLoan': !exists(json, 'otherReasonOfLoan') ? undefined : json['otherReasonOfLoan'],
        'coappliant': !exists(json, 'coappliant') ? undefined : json['coappliant'],
        'maritalExpenses': !exists(json, 'maritalExpenses') ? undefined : json['maritalExpenses'],
        'regNr': !exists(json, 'regNr') ? undefined : json['regNr'],
        'accountNr': !exists(json, 'accountNr') ? undefined : json['accountNr'],
        'termsOfService': json['termsOfService'],
        'marketing': json['marketing'],
        'creditCheck': json['creditCheck'],
        'eSkatConsent': json['eSkatConsent'],
        'insurance': json['insurance'],
        'cars': !exists(json, 'cars') ? undefined : (json['cars'] === null ? null : (json['cars'] as Array<any>).map(CarFromJSON)),
        'paymentMethod': PaymentMethodFromJSON(json['paymentMethod']),
        'hasOldLoan': HasOldLoanFromJSON(json['hasOldLoan']),
        'sharedExpenses': SharedExpensesFromJSON(json['sharedExpenses']),
        'step2AltLink': !exists(json, 'step2AltLink') ? undefined : json['step2AltLink'],
        'step2AltText': !exists(json, 'step2AltText') ? undefined : json['step2AltText'],
    };
}

export function ApplicationRequestToJSON(value?: ApplicationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'loanAmount': value.loanAmount,
        'startAmount': value.startAmount,
        'repaymentPeriod': value.repaymentPeriod,
        'cpr': value.cpr,
        'oldLoanAmount': value.oldLoanAmount,
        'name': value.name,
        'mobile': value.mobile,
        'email': value.email,
        'address': value.address,
        'postalcode': value.postalcode,
        'city': value.city,
        'aseConsent': value.aseConsent,
        'marketingConsent': value.marketingConsent,
        'almBrandConsent': value.almBrandConsent,
        'coname': value.coname,
        'coemail': value.coemail,
        'cocpr': value.cocpr,
        'married': value.married,
        'rki': value.rki,
        'dwelling': value.dwelling,
        'rent': value.rent,
        'children': value.children === undefined ? undefined : (value.children === null ? null : (value.children as Array<any>).map(ChildToJSON)),
        'reasonOfLoan': value.reasonOfLoan,
        'otherReasonOfLoan': value.otherReasonOfLoan,
        'coappliant': value.coappliant,
        'maritalExpenses': value.maritalExpenses,
        'regNr': value.regNr,
        'accountNr': value.accountNr,
        'termsOfService': value.termsOfService,
        'marketing': value.marketing,
        'creditCheck': value.creditCheck,
        'eSkatConsent': value.eSkatConsent,
        'insurance': value.insurance,
        'cars': value.cars === undefined ? undefined : (value.cars === null ? null : (value.cars as Array<any>).map(CarToJSON)),
        'paymentMethod': PaymentMethodToJSON(value.paymentMethod),
        'hasOldLoan': HasOldLoanToJSON(value.hasOldLoan),
        'sharedExpenses': SharedExpensesToJSON(value.sharedExpenses),
        'step2AltLink': value.step2AltLink,
        'step2AltText': value.step2AltText,
    };
}


